// src/api/supportResources.js
import client from './api';

const list = async (params = {}) => {
  const { data } = await client.get('/support/resources', { params });
  return data;
};

const create = async (formData) => {
  const { data } = await client.post('/support/resources', formData);
  return data;
};

const remove = async (resourceId) => {
  const { data } = await client.delete(`/support/resources/${resourceId}`);
  return data;
};

export default {
  list,
  create,
  remove,
};
